import { useRef, useEffect, MutableRefObject } from 'react';

/**
 * 値が更新されるたびに ref.current を同期するカスタムフック。
 * useRef + useEffect の重複パターンを一行にまとめる。
 */
export function useSyncedRef<T>(value: T): MutableRefObject<T> {
  const ref = useRef(value);
  useEffect(() => {
    ref.current = value;
  }, [value]);
  return ref;
}
